import React, { FC, useEffect, useState } from "react";
import {
  Form,
  Button,
  Card,
  Spinner,
  Row,
  Col,
  CardBody,
} from "react-bootstrap";
import { getHeaderTagsResponse } from "../../../services/getAiResponse";
import { HeaderTags } from "../types";
import { HelpModal } from "../../common/compoents/HelpModal";
import { ToolsHeader } from "../../components/ToolsHeader";
import { isInIframe } from "../../../utils/is-in-iframe";
import { Box } from "./headerTagsGenStyle";
import { validateArticleContent } from "../../../utils/validators";

type Props = {};

const helpSteps = [
  "Paste the content into the designated text area.",
  "Click 'Generate Tags' to generate the Heading Tags.",
];

export const HeaderTagsGenerator: FC<Props> = () => {
  const [content, setContent] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [generatedHeaders, setGeneratedHeaders] = useState<HeaderTags[]>([]);
  const [showVideoModal, setShowVideoModal] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const handleContentChange = (
    e: React.ChangeEvent<HTMLTextAreaElement>
  ) => {
    setContent(e.target.value);
  };

  useEffect(() => {
    const height = document.body.scrollHeight;
    window.parent.postMessage({ type: "setHeight", height }, "*");
  }, [generatedHeaders]);

  const handleGenerateTags = async () => {
    const validationError = validateArticleContent(content);

    if (validationError) {
      setError(validationError);
      return;
    }

    setError(null);
    setIsLoading(true);

    try {
      const response = await getHeaderTagsResponse(content);
      if (response) {
        const data = JSON.parse(
          response.replaceAll("```json", "").replaceAll("```", "")
        );
        setGeneratedHeaders(data);
      }
    } catch (err) {
      console.error("Error generating headers:", err);
    } finally {
      setIsLoading(false);
    }
  };


  const renderHeaders = (headers: HeaderTags[]) => (
    <ul>
      {headers.map((header, index) => (
        <li key={index}>
          {header.tag?.toUpperCase()}: <i>{header.headingName}</i>
          {header.children.length > 0 && renderHeaders(header.children)}
        </li>
      ))}
    </ul>
  );

  return (
    <Box>
      <Row
        style={{ padding: isInIframe ? "0" : "10px" }}
        className={`${isInIframe && "interDisplay"}`}
      >
        <Col className="p-0">
          <HelpModal
            helpSteps={helpSteps}
            show={showVideoModal}
            close={() => setShowVideoModal(false)}
            videoUrl="https://www.youtube.com/embed/hNce9hFpBOY"
          />

          {!isInIframe && (
            <ToolsHeader
              title="Header Tags Generator"
              description="Smart tool to generate optimized H1, H2, H3 headings for your article or content with ease."
            />
          )}

          <Card className="headerTagsCard">
            <Form>
              <Form.Group controlId="headerTagsInput">
                <Form.Label>Your Article</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={8}
                  placeholder="Paste the content of the article that you want to generate headings"
                  value={content}
                  onChange={handleContentChange}
                  style={{ resize: "vertical" }}
                  isInvalid={!!error}
                />
                <Form.Control.Feedback type="invalid">
                  {error}
                </Form.Control.Feedback>
              </Form.Group>

              <div className="text-center mt-4">
                {isLoading ? (
                  <Spinner animation="border" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </Spinner>
                ) : (
                  <Button
                    style={{ backgroundColor: "#8cc540" }}
                    onClick={handleGenerateTags}
                  >
                    Generate Tags
                  </Button>
                )}
              </div>
            </Form>

            {generatedHeaders.length > 0 && (
              <div className="mt-3">
                <Card className="resultCard">
                  <CardBody>
                    <h5>Generated Header Tags:</h5>
                    {renderHeaders(generatedHeaders)}
                  </CardBody>
                </Card>
              </div>
            )}
          </Card>
        </Col>
      </Row>
    </Box>
  );
};